import { resourcesParams } from "./resources.params"
import _ from "lodash"

const baseMessages = {
    internal: {
        actions: "Действия",
        errors: {
            "Error on parse data": "Ошибка парсинга данных",
        },
        list: "Список",
        tree: "Иерархия",
        audit: "Аудит изменений",
        edit: "Редактирование",
        show: "Просмотр",
        success: "Успешно",
        error: "Ошибка",
        create: "Создание",
        cancel: "Отмена",
        confirm: "Подтверждение",
        settings: "Настройки",
        resetZoom: "Сброс масштабирования",
        fullscreen: "Полноэкранный режим",
        daterange: "Диапазон дат",
        current_data: "Текущие данные",
        online: "Режим реального времени",
        historical_data: "Исторические данные",
        company_resource: "Ресурсопоставляющая компания",
        company_customer: "Потребитель",
        company_service: "Обслуживающая компания",
        coordinate_picker: {
            select_on_map: "Выбрать на карте",
            title: "Выберите координаты на карте",
            hint: "Кликните на карту для выбора координат или введите их вручную",
            latitude: "Широта",
            longitude: "Долгота",
            selected: "Выбранные координаты",
        },
    },
    menu: {
        reference_books: "Справочники",
        drivers_params: "Драйвера и параметры",
    },
    dashboard: {
        welcome: {
            title: "Панель управления",
            subtitle: "Обзор системы в реальном времени",
        },
        stats: {
            objects: "Объекты",
            devices: "Устройства", 
            users: "Пользователи",
        },
        error: {
            loading: "Ошибка загрузки данных дашборда",
        },
    },
    resources: {
        audit: {
            field_history: "История поля",
            current_value: "Текущее значение",
            no_history: "История изменений не найдена",
            changes: "Изменения",
            action: "Действие",
            update: "Редактирование",
            create: "Создание",
            was: "Было",
            became: "Стало",
            date_time: "Дата и время",
            user: "Пользователь",
            loading: "Загрузка...",
            system: "Система",
            deleted: "удалено",
            close: "Закрыть",
            yes: "Да",
            no: "Нет",
            table: "Таблица",
            record_id: "ID"
        },
        units: {
            name: "Единицы измерения",
            values: {
                kpa: "кПа",
                mpa: "МПа",
                pa: "Па",
                c: "C",
                f: "F",
            },
        },
        common: {
            fields: {
                description: "Описание",
                varname: "Код",
                parent_varname: "Код родителя",
                created_at: "Дата создания",
                updated_at: "Дата редактирования",
                timezone: "Часовой пояс",
            },
        },
        users: {
            name: "Пользователи",
            fields: {
                login: "Логин",
                name: "Имя",
                email: "Электронная почта",
                active: "Активен",
                roles: "Роли",
                profiles: "Профили",
                current_profile: "Текущий профиль",
                password: "Пароль",
                repeat_password: "Повторный пароль",
            },
        },
        companies: {
            name: "Компании",
            fields: {
                name: "Полное название компании",
                parent_id: "Родительская компания",
                short_name: "Краткое название компании",
                email: "Электронная почта",
                timezone: "Временная зона",
                type_id: "Тип компании",
            },
        },
        dashboards: {
            name: "Дашборды",
            fields: {
                name: "Название",
                description: "Описание",
                widgets_count: "Количество виджетов",
                is_public: "Доступ",
            },
            values: {
                public: "Публичный",
                private: "Приватный",
            },
            actions: {
                add_widget: "Добавить виджет",
                add_first_widget: "Добавить первый виджет",
                delete_widget: "Удалить",
                edit_widget: "Редактировать",
            },
            messages: {
                loading: "Загрузка дашборда...",
                error_loading: "Ошибка загрузки дашборда",
                not_found: "Дашборд не найден",
                empty_title: "Дашборд пуст",
                empty_subtitle: "Добавьте виджеты для отображения данных",
                delete_confirm_title: "Подтвердите удаление",
                delete_confirm_message: "Вы действительно хотите удалить виджет \"%{title}\"? Это действие нельзя отменить.",
                cancel: "Отмена",
                delete: "Удалить",
                unknown_error: "Неизвестная ошибка",
                unknown_widget_type: "Неизвестный тип виджета: %{type}",
                unsupported_widget_type: "Неподдерживаемый тип виджета: %{type}",
            },
            wizard: {
                title: "Создание дашборда",
                step_template: "Выбор шаблона",
                step_settings: "Настройки дашборда",
                step_confirmation: "Подтверждение",
                select_template: "Выберите шаблон дашборда",
                select_template_hint: "Выберите один из готовых шаблонов или создайте пустой дашборд",
                empty_dashboard: "Пустой дашборд",
                empty_dashboard_hint: "Создать дашборд без шаблона и добавить виджеты самостоятельно",
                widgets_count: "Виджеты: %{count}",
                category_empty: "Категория: Пустой",
                category_label: "Категория: %{category}",
                dashboard_settings: "Настройки дашборда",
                dashboard_settings_hint: "Настройте основные параметры вашего дашборда",
                dashboard_name: "Название дашборда",
                dashboard_name_hint: "Введите понятное название для вашего дашборда",
                dashboard_description: "Описание",
                dashboard_description_hint: "Опишите назначение и содержимое дашборда",
                public_dashboard: "Публичный дашборд",
                public_dashboard_hint: "Публичные дашборды доступны всем пользователям системы",
                confirmation: "Подтверждение создания",
                confirmation_hint: "Проверьте настройки перед созданием дашборда",
                template_label: "Шаблон:",
                name_label: "Название:",
                description_label: "Описание:",
                access_label: "Доступ:",
                back: "Назад",
                next: "Далее",
                create: "Создать дашборд",
                creating: "Создание...",
            },
            widgets: {
                default_title: "Виджет",
                actions: {
                    refresh: "Обновить",
                    edit: "Редактировать",
                    delete: "Удалить"
                },
                chart: {
                    name: "График",
                    description: "Отображение данных в виде графиков и диаграмм",
                    type: "Тип",
                    data_sources: "Источников данных: %{count}",
                    demo_data: "Демо-данные • Последние 24 часа",
                    no_data_source: "Не настроен источник данных",
                    no_data: "Нет данных для отображения",
                    configure_data_source: "Добавьте источник данных в настройках виджета",
                    load_error: "Ошибка загрузки данных графика"
                },
                table: {
                    name: "Таблица",
                    description: "Табличное представление данных",
                    search: "Поиск...",
                    no_data_source: "Источник данных не настроен",
                    no_data: "Нет данных для отображения",
                    error_loading: "Ошибка загрузки данных",
                    showing: "Показано %{from}-%{to} из %{total}",
                    total_records: "Всего записей: %{count}",
                    columns: {
                        timestamp: "Время",
                        value: "Значение",
                        parameter: "Параметр"
                    }
                },
                gauge: {
                    name: "Индикатор",
                    description: "Круговые индикаторы для отображения показателей",
                    errors: {
                        no_param: "Не указан параметр",
                        param_not_found: "Параметр не найден: %{id}",
                        load_failed: "Ошибка загрузки данных индикатора"
                    },
                    status: {
                        normal: "Норма",
                        warning: "Предупреждение",
                        critical: "Критично",
                        threshold: "Порог"
                    },
                    thresholds: {
                        low: "Низкий",
                        high: "Высокий"
                    }
                },
                text: {
                    name: "Текстовый блок",
                    description: "Отображение текстовой информации",
                    empty_content: "Добавьте текстовое содержимое в настройках виджета"
                },
                schema: {
                    name: "Схема",
                    description: "Схематичное представление данных",
                    elements: {
                        tank: "Резервуар",
                        pump: "Насос",
                        valve: "Клапан"
                    },
                    data_sources: "Источники данных",
                    no_data_source: "Нет источников данных для отображения",
                    error_loading: "Ошибка загрузки данных схемы",
                    custom_schema: "Пользовательская схема",
                    parameters: "Параметры"
                },
                map: {
                    name: "Карта",
                    description: "Географическое отображение объектов",
                    data_sources: "Источники данных",
                    no_data_source: "Нет источников данных для отображения",
                    error_loading: "Ошибка загрузки данных карты",
                    device: "Устройство",
                    object: "Объект",
                    value: "Значение",
                    status: "Статус",
                    position: "Позиция",
                    updated: "Обновлено"
                }
            },
            widget_wizard: {
                title: "Добавить виджет",
                step_type: "Выбор типа",
                step_settings: "Настройки",
                step_confirmation: "Подтверждение",
                select_widget_type: "Выберите тип виджета",
                select_widget_type_hint: "Выберите подходящий тип виджета для отображения ваших данных",
                widget_settings: "Настройки виджета",
                widget_settings_hint: "Настройте основные параметры виджета",
                widget_name: "Название виджета",
                widget_name_hint: "Введите понятное название для виджета",
                content: "Содержимое",
                content_hint: "Введите текстовое содержимое виджета",
                data_source: "Источники данных",
                data_source_hint: "Выберите объект, устройство и параметр для отображения данных",
                select_object: "Выберите объект",
                select_device: "Выберите устройство",
                select_archive_type: "Выберите тип архива",
                select_param: "Выберите параметр",
                no_objects: "Объекты не найдены",
                no_devices: "Устройства не найдены",
                no_archive_types: "Типы архивов не найдены",
                no_params: "Параметры не найдены",
                selected_data_sources: "Выбранные источники данных",
                chart_type: "Тип графика",
                chart_line: "Линейный",
                chart_bar: "Столбчатый",
                chart_area: "Области",
                chart_pie: "Круговая диаграмма",
                confirmation: "Подтверждение создания",
                confirmation_hint: "Проверьте настройки перед созданием виджета",
                size_label: "Размер виджета:",
                size_value: "%{width} × %{height} ячеек",
                name_label: "Название виджета:",
                back: "Назад",
                next: "Далее",
                create: "Создать виджет",
                creating: "Создание...",
                update: "Сохранить изменения",
                updating: "Сохранение...",
                edit_title: "Редактирование виджета",
                new_widget_title: "Новый %{type}",
                default_text_content: "Добавьте ваш текст здесь",
                device: "Устройство",
                archive_type: "Тип архива",
                param: "Параметр",
                object: "Объект",
                not_selected: "Не выбрано",
                min_value: "Минимальное значение",
                min_value_hint: "Установите минимальное значение шкалы датчика",
                max_value: "Максимальное значение",
                max_value_hint: "Установите максимальное значение шкалы датчика",
                unit: "Единица измерения",
                unit_hint: "Введите единицу измерения (например, кВт, °C, %)",
                gauge_single_param_hint: "Виджет датчика отображает один параметр. Выберите один источник данных.",
                table_config_coming_soon: "Конфигурация таблицы еще не полностью реализована.",
                table_config_hint: "Вы можете создать виджет, но настройка источника данных будет доступна в будущих обновлениях.",
                loading_data: "Загрузка данных"
            },
            errors: {
                load_objects_failed: "Не удалось загрузить список объектов",
                load_devices_failed: "Не удалось загрузить список устройств",
                load_archive_types_failed: "Не удалось загрузить список типов архивов",
                load_params_failed: "Не удалось загрузить список параметров"
            },
        },
        equipments: {
            name: "Оборудование",
            fields: {
                name: "Полное название прибора",
                label: "Краткое название",
                equipment_kind_id: "Тип прибора",
                equipment_driver_id: "Драйвер",
                manufacturer_company_id: "Производитель",
                energy_kind_id: "Тип энергоресурса",
                sensor_min: "Мин. значение датчика",
                sensor_max: "Макс. значение датчика",
                sensor_unit: "Ед. измерения датчика",
            },
        },
        equipmentdrivers: {
            name: "Список драйверов",
            paramstitle: "Параметры драйвера",
            fields: {
                name: "Наименование драйвера",
            },
        },
        paramsettings: {
            fields: {
                name: "Имя параметра",
                label: "Маркировка",
                data_type: "Тип",
                data_column_name: "Имя колонки в таблице",
                data_table_name: "Имя таблицы",
                decimal_places: "Кол-во знаков после запятой",
                archive_type_id: "Архив",
                unit_id: "Ед. измерения",
            },
        },
        objects: {
            name: "Объекты учета",
            scheme_gts: "Схема ГТС",
            map: "ГТС на карте",
            fields: {
                name: "Название объекта",
                object_category_id: "Категория",
                object_industry_ids: "Тип объекта/Направление деятельности",
                address: "Адрес",
                parent_ids: "Родительские объекты",
                geoposition: "Координаты",
                coordinate_picker: {
                    title: "Выберите координаты на карте",
                    hint: "Кликните на карту для выбора координат или введите их вручную:",
                    latitude: "Широта",
                    longitude: "Долгота",
                    selected: "Выбранные координаты",
                    select_on_map: "Выбрать на карте",
                },
            },
        },
        schedules:{
            name: "Расписания",
            create: "Создать расписание",
            edit: "Редактирование расписания",
            fields: {
                date_start: "Дата начала действия",
                date_end: "Дата окончания действия",
                crontab: "Значение расписания",
                active: "Включено",
                randomize: "Функция рандомизации",
                description: "Примечание",
            },
        },
        devices: {
            name: "Устройства",
            chart: "График",
            data: "Журнал данных",
            ddt: "ДДТ",
            fields: {
                name: "Название",
                imei: "IMEI",
                phone: "Номер телефона",
                iccid: "ICCID",
                device_kind_id: "Тип устройства",
                energy_kind_id: "Тип энергоресурса",
                object_id: "Объект",
                equipment_ids: "Оборудование",
                equipment_id_bbt: "Телеметрия",
                equipment_serial_numbers: "Серийный номер",
                equipment_serial_number_bbt: "Серийный номер блока телеметрии",
            },
        },
        devicesddt: {
            name:  "ДДТ",
            journal: "Журнал данных",
            fields: {
                treshold_p: "Пороги аварий для давления",
                treshold_t: "Пороги аварий для температуры",
            },
        },
    },
}

const customRussianMessages = _.defaultsDeep({}, baseMessages, resourcesParams)
export default customRussianMessages
